import { transient } from "aurelia-dependency-injection";

@transient()
export class MaxLengthValueConverter {
    public toView(value: string, length:number): string {
        return value? value.substr(0,length): value;
    }

    public fromView(value: string, length:number): string {
        return value? value.substr(0,length): value;
    }
}